import { React } from "react";
import { FaGithub, FaLinkedin, FaMedium } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bottom-0 flex max-h-16 w-full flex-row justify-center bg-light-primary-2 dark:bg-dark-primary-1">
      <ul className="flex max-w-screen-md grow flex-row items-stretch justify-around py-5">
        <li className="text-4xl text-light-secondary-2 dark:text-dark-primary-2">
          <a href="https://github.com/gautham18113">
            <FaGithub />
          </a>
        </li>
        <li className="text-4xl text-light-secondary-2 dark:text-dark-primary-2">
          <a href="https://www.linkedin.com/in/gautham-91/">
            <FaLinkedin />
          </a>
        </li>
        <li className="text-4xl text-light-secondary-2 dark:text-dark-primary-2">
          <a href="https://medium.com/@gautham18113">
            <FaMedium />
          </a>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
